import {Routes} from '@angular/router';
import {AuthComponent} from "./pages/auth/auth.component";
import {SurveyPageComponent} from "./pages/survey-page/survey-page.component";
import {SessionService} from "./services/session.service";
import {SurveyService} from "./services/survey.service";
import {ErrorComponent} from "./pages/error/error.component";
import { LogoService } from './services/logo.service';
import { CsatComponent } from "./pages/csat/csat.component";

export const routes:Routes = [
	{
		path: "error/:error-reason",
		title: "Error",
		component: ErrorComponent,
		canActivate: [SurveyService.canActivateCommonModules]
	},
	{
		path: ":surveyId",
		resolve: [LogoService.resolveLogo],
		canActivate: [SurveyService.canActivateCommonModules],
		children: [
			{
				path: "auth",
				title: "Patient Questionnaire",
				component: AuthComponent
			},
			{
				path: "csat",
				component: CsatComponent,
				canActivate: [SessionService.canActivateAuthenticated, SurveyService.canActivate],

			},
			{
				path: ":page",
				component: SurveyPageComponent,
				canActivate: [SessionService.canActivateAuthenticated, SurveyService.canActivate]
			},
			{
				path: "",
				redirectTo: "0",
				pathMatch: "prefix"
			}
		]
	}
];
